<p>
  Please wait while we get things ready for you...
</p>

<p class="loading-icon">
  <fa-icon [icon]="faArrowsRotate"></fa-icon>
</p>
